import React from 'react';
import { backgroundSyncService, BackgroundSyncStatus } from '@/services/backgroundSyncService';

export const useBackgroundSync = () => {
  const [status, setStatus] = React.useState<BackgroundSyncStatus>(
    backgroundSyncService.getStatus()
  );

  React.useEffect(() => {
    const updateStatus = () => {
      setStatus(backgroundSyncService.getStatus());
    };

    // Écouter les événements de changement de statut
    window.addEventListener('background-sync-success', updateStatus);
    window.addEventListener('background-sync-error', updateStatus);

    // Mettre à jour le statut initial
    updateStatus();

    return () => {
      window.removeEventListener('background-sync-success', updateStatus);
      window.removeEventListener('background-sync-error', updateStatus);
    };
  }, []);

  return {
    status,
    start: () => backgroundSyncService.start(),
    stop: () => backgroundSyncService.stop(),
    forceSync: () => backgroundSyncService.forceSync(),
    getPendingChangesCount: () => backgroundSyncService.getPendingChangesCount(),
    getDiagnostics: () => backgroundSyncService.getDiagnostics(),
    cleanup: () => backgroundSyncService.cleanup()
  };
};
